module.exports = __webpack_public_path__ + "fonts/15533d2adbded9a8c1d45fd591ea8f72.txt";